import { SurfaceConstants, VisibleTime } from 'owa-calendar-surface-core';
import type { CalendarSurfaceStore } from '../index';
import { differenceInMinutes, now, today, getDay } from 'owa-datetime';
import { isDateInDateRange } from 'owa-datetime-utils';

/**
 * This function calculates scroll top offset for surface day/week view based on today and working hours configuration
 * Scrolls to current time if day is in range. Otherwise scrolls to working hours.
 * @param {CalendarSurfaceStore} store - the calendar surface store
 * @returns scroll position for for current range
 */
export default function calculateScrollOffset(store: CalendarSurfaceStore): number {
    const currentDay = today();

    if (isDateInDateRange(store.dateRange, currentDay)) {
        return getScrollTop(store, differenceInMinutes(now(), currentDay));
    }

    const dayOfWeek = getDay(store.dateRange.start);

    // if user has set up different work hours at day level, scroll to the relevant working hours for the day
    const offsetInMinutes =
        store.userOptions?.workDaysWiseHoursStartTimeInMinutes?.length > 0
            ? store.userOptions.workDaysWiseHoursStartTimeInMinutes[dayOfWeek][0]
            : store.userOptions.workHoursStartTimeInMinutes;

    return getScrollTop(store, offsetInMinutes);
}

function getScrollTop(store: VisibleTime, offsetInMinutes: number): number {
    return Math.ceil(offsetInMinutes) - store.dayStartMinute - SurfaceConstants.scrollTopAdjustment;
}
